import React from "react";
import classes from "./Budget.module.css";
import Header from "./BudgetHeader/BudgetHeader";
import TableInput from "./TableInput/TableInput";
import Loader from "../../Components/Loader/Loader";
import Notification from "../../Components/Notification/Notification";
import { Route, Link, withRouter } from "react-router-dom";
import API from "../../API/REST_API";

class Budget extends React.Component {
  state = {
    date: "",
    screeWidth: 0,
    header_title: "",
    category_height: 300,
    subCategory: [],
    categoriesWithBudget: {}, // Map of category title to budget info
    category: {
      income: {
        title: "Income",
        path: "/budget/income",
        data: [],
      },
      saving: {
        title: "Saving",
        path: "/budget/saving",
        data: [],
      },
      const_expense: {
        title: "Fixed Expenses",
        path: "/budget/fixedexpenses",
        data: [],
      },
      expense: {
        title: "Expenses",
        path: "/budget/expenses",
        data: [],
      },
    },
    pieChart: {
      options: {
        legend: {
          show: false,
        },
        chart: {
          id: "basic-bar",
        },
        labels: [
          "Income",
          "Saving",
          "Fixed Expenses",
          "Expenses",
          "Free Budget",
        ],
      },
      series: [10, 10, 10, 10],
      width: 350,
      type: "pie",
      title: "",
    },
    barChart: {
      options: {
        chart: {
          type: "bar",
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: [["Inc"], ["Sav"], ["Fixed"], ["Exp"], ["Free"]],
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
      },
      series: [
        {
          data: [0, 0, 0, 0, 0],
        },
      ],
      width: 350,
      type: "bar",
      title: "",
    },
    loaded: false,
    const_expence_update: false,
    showNotification: false,
    notificationMessage: "",
  };

  resize() {
    let pieChart = JSON.parse(JSON.stringify(this.state.pieChart));
    let barChart = JSON.parse(JSON.stringify(this.state.barChart));
    if (window.innerWidth < 850) {
      pieChart.width = 220;
      barChart.width = 280;
      this.setState({
        screeWidth: window.innerWidth,
        pieChart,
        barChart,
      });
    } else {
      let width = window.innerWidth / 3;
      if (width > 500) width = 450;
      if (width < 280) width = 280;
      width = 400;
      pieChart.width = width - 100;
      barChart.width = width + 30;

      this.setState({
        screeWidth: window.innerWidth,
        pieChart,
        barChart,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => {});
  }
  componentDidMount = async () => {
    this.resize();
    window.addEventListener("resize", () => {
      this.resize();
    });

    let date = new Date().toISOString().split("-");
    date = date[1] + "-" + date[0];
    this.setState({
      date,
    });
    this.selectDateHandler(date);
    this.load_categories();
  };
  formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  // Monthly amount for one fixed-expense row (same formula as getTotals)
  getMonthlyAmountForFixedExpense = (item) => {
    if (item.to_date === 999999 || !item.from_date || !item.to_date) return item.sum;
    // If explicitly marked as NOT a payment expense, sum is already monthly
    if (item.is_payment === false) return item.sum;
    // is_payment === true OR null (old data) → divide by months
    const fromYear = Math.floor(item.from_date / 100);
    const fromMonth = item.from_date % 100;
    const toYear = Math.floor(item.to_date / 100);
    const toMonth = item.to_date % 100;
    const totalPayments = (toYear - fromYear) * 12 + (toMonth - fromMonth) + 1;
    return totalPayments > 0 ? item.sum / totalPayments : item.sum;
  };

  // Spent per category for fixed expenses (for budget badge) – uses total payments, not remaining
  getFixedExpenseSpentByCategory = () => {
    const { category } = this.state;
    const byCategory = {};
    category.const_expense.data.forEach((item) => {
      const cat = item.category || "";
      const monthly = this.getMonthlyAmountForFixedExpense(item);
      byCategory[cat] = (byCategory[cat] || 0) + monthly;
    });
    return byCategory;
  };

  // For Fixed Expenses tab: merge computed spent (monthly amount) so badge shows correct %
  getCategoriesWithBudgetForFixedExpenses = () => {
    const base = this.state.categoriesWithBudget || {};
    const fixedSpent = this.getFixedExpenseSpentByCategory();
    const merged = { ...base };
    Object.keys(fixedSpent).forEach((cat) => {
      if (merged[cat] != null && merged[cat].budget != null) {
        const spent = fixedSpent[cat];
        merged[cat] = {
          ...merged[cat],
          spent,
          remaining: merged[cat].budget - spent,
          isOverBudget: spent > merged[cat].budget,
        };
      }
    });
    return merged;
  };

  getTotals = () => {
    const { category } = this.state;
    const income = category.income.data.reduce((sum, item) => sum + item.sum, 0);
    const saving = category.saving.data.reduce((sum, item) => sum + item.sum, 0);
    const fixedExpenses = category.const_expense.data.reduce(
      (sum, item) => sum + this.getMonthlyAmountForFixedExpense(item),
      0
    );
    const expenses = category.expense.data.reduce((sum, item) => sum + item.sum, 0);
    const freeBudget = income - saving - fixedExpenses - expenses;
    return { income, saving, fixedExpenses, expenses, freeBudget };
  };

  render() {
    const currentPath = this.props.location?.pathname || "";
    const totals = this.getTotals();
    
    // Extract expenseId from URL query parameters
    const urlParams = new URLSearchParams(this.props.location?.search || "");
    const expenseId = urlParams.get("expenseId");

    let sub_menus = (
      <React.Fragment>
        <Route path={this.state.category.income.path}>
          <TableInput
            title={"Income"}
            data={this.state.category.income.data}
            onChange={this.onChange}
            screeWidth={this.state.screeWidth}
            delete_rec_by_id={this.delete_rec_by_id}
            categories={this.state.subCategory}
            saveUpdateValueHandler={this.saveUpdateValueHandler}
            remove_enabled={this.props.user.remove_enabled}
            symbol={this.props.settings?.symbol || ""}
            expenseId={expenseId}
            categoriesWithBudget={this.state.categoriesWithBudget}
          ></TableInput>
        </Route>
        <Route path={this.state.category.saving.path}>
          <TableInput
            title={"Saving"}
            data={this.state.category.saving.data}
            onChange={this.onChange}
            screeWidth={this.state.screeWidth}
            delete_rec_by_id={this.delete_rec_by_id}
            categories={this.state.subCategory}
            saveUpdateValueHandler={this.saveUpdateValueHandler}
            remove_enabled={this.props.user.remove_enabled}
            symbol={this.props.settings?.symbol || ""}
            expenseId={expenseId}
            categoriesWithBudget={this.state.categoriesWithBudget}
          ></TableInput>
        </Route>
        <Route path={this.state.category.const_expense.path}>
          <TableInput
            title={"Fixed Expenses"}
            data={this.state.category.const_expense.data}
            onChange={this.onChange}
            screeWidth={this.state.screeWidth}
            delete_rec_by_id={this.delete_rec_by_id}
            categories={this.state.subCategory}
            saveUpdateValueHandler={this.saveUpdateValueHandler}
            remove_enabled={this.props.user.remove_enabled}
            symbol={this.props.settings?.symbol || ""}
            expenseId={expenseId}
            categoriesWithBudget={this.getCategoriesWithBudgetForFixedExpenses()}
            currentDate={this.state.date}
            selectDateHandler={this.selectDateHandler}
          ></TableInput>
        </Route>
        <Route path={this.state.category.expense.path}>
          <TableInput
            title={"Expenses"}
            categories={this.state.subCategory}
            data={this.state.category.expense.data}
            onChange={this.onChange}
            screeWidth={this.state.screeWidth}
            delete_rec_by_id={this.delete_rec_by_id}
            saveUpdateValueHandler={this.saveUpdateValueHandler}
            remove_enabled={this.props.user.remove_enabled}
            symbol={this.props.settings?.symbol || ""}
            expenseId={expenseId}
            categoriesWithBudget={this.state.categoriesWithBudget}
          ></TableInput>
        </Route>
      </React.Fragment>
    );
    if (!this.state.loaded)
      sub_menus = (
        <div className={classes.loader}>
          <Loader></Loader>
        </div>
      );

    const navItems = [
      {
        path: "/budget/income",
        label: "Income",
        value: totals.income,
        color: "text-green-600",
        activeBg: "ring-2 ring-green-500",
      },
      {
        path: "/budget/saving",
        label: "Savings",
        value: totals.saving,
        color: "text-blue-600",
        activeBg: "ring-2 ring-blue-500",
      },
      {
        path: "/budget/fixedexpenses",
        label: "Fixed Expenses",
        value: totals.fixedExpenses,
        color: "text-amber-600",
        activeBg: "ring-2 ring-amber-500",
      },
      {
        path: "/budget/expenses",
        label: "Expenses",
        value: totals.expenses,
        color: "text-red-600",
        activeBg: "ring-2 ring-red-500",
      },
    ];

    return (
      <div className="flex min-h-full flex-col bg-slate-50 md:h-full">
        {/* Datepicker Header - fixed on mobile below main header, relative on desktop */}
        <div 
          className="fixed left-0 right-0 z-20 md:relative md:z-10"
          style={{ top: "50px" }}
        >
          <div className="md:hidden">
            <Header
              title={this.state.header_title}
              selectDateHandler={this.selectDateHandler}
              currentDate={this.state.date}
            ></Header>
          </div>
        </div>
        
        {/* Desktop Header - spans full width of content area */}
        <div className="hidden md:block flex-shrink-0">
          <Header
            title={this.state.header_title}
            selectDateHandler={this.selectDateHandler}
            currentDate={this.state.date}
          ></Header>
        </div>
        
        {/* Spacer for fixed datepicker on mobile (datepicker is ~56px) */}
        <div className="h-14 flex-shrink-0 md:hidden"></div>

        {/* Summary Cards Navigation */}
        <div className="px-2 py-2 sm:px-4 sm:py-4 flex-shrink-0 mt-2 md:mt-0">
          <div className="grid grid-cols-3 gap-1.5 sm:grid-cols-3 sm:gap-3 lg:grid-cols-5">
            {navItems.map((item) => {
              const isActive = currentPath === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`group rounded-lg border border-slate-200 bg-white p-2 shadow-sm transition hover:shadow-md sm:rounded-xl sm:p-4 ${
                    isActive ? item.activeBg : ""
                  }`}
                >
                  <p className="truncate text-xs font-medium text-gray-500 sm:text-sm">{item.label}</p>
                  <p className={`mt-0.5 text-sm font-semibold sm:mt-1 sm:text-xl ${item.color}`}>
                    {this.state.loaded ? this.formatCurrency(item.value, this.props.settings?.symbol || "") : "..."}
                  </p>
                </Link>
              );
            })}
            <div className="col-span-3 rounded-lg border border-slate-200 bg-white p-2 shadow-sm sm:col-span-1 sm:rounded-xl sm:p-4 lg:col-span-1">
              <p className="text-xs font-medium text-gray-500 sm:text-sm">Free Budget</p>
              <p
                className={`mt-0.5 text-sm font-semibold sm:mt-1 sm:text-xl ${
                  totals.freeBudget >= 0 ? "text-indigo-600" : "text-red-600"
                }`}
              >
                {this.state.loaded ? this.formatCurrency(totals.freeBudget, this.props.settings?.symbol || "") : "..."}
              </p>
            </div>
          </div>
        </div>

        {/* Table Content - scrollable on desktop only */}
        <div className="flex-1 md:overflow-y-auto">
          <div className="px-4 pb-6">
            {sub_menus}
          </div>
        </div>
        
        {/* Notification */}
        <Notification
          message={this.state.notificationMessage}
          type="success"
          show={this.state.showNotification}
          onClose={() => this.setState({ showNotification: false, notificationMessage: "" })}
          duration={3000}
        />
      </div>
    );
  }
  saveUpdateValueHandler = async (
    categoryName,
    index,
    type,
    value,
    id,
    from_date,
    to_date,
    updated
  ) => {
    try {
      let body = {};
      let updatedExpense = null;
      
      // Determine if this is a fixed expense by checking the category
      const isFixedExpense = categoryName === "Fixed Expenses";
      
      console.log("saveUpdateValueHandler called:", { categoryName, type, value, id, isFixedExpense });
      
      // For fixed expenses, always include current_date to enable split logic
      if (isFixedExpense) {
        const dateParts = this.state.date.split("-");
        body.current_date = parseInt(dateParts[1] + dateParts[0], 10);
        console.log("Added current_date to body:", body.current_date, "from date:", this.state.date);
      }
      
      if (type === "title") {
        body.title = value.value;
        updatedExpense = await this.update_rec_by_id(id, body);
      }
      if (type === "sum") {
        body.sum = +value.value;
        updatedExpense = await this.update_rec_by_id(id, body);
      }
      if (type === "category") {
        body.category = value.value;
        updatedExpense = await this.update_rec_by_id(id, body);
      }
      if (type === "payments") {
        body.payments = +value.value;
        body.from_date = from_date; // Server needs from_date to calculate to_date
        console.log("Payments update request:", { id, body, from_date_original: from_date, datePicker: this.state.date });
        updatedExpense = await this.update_rec_by_id(id, body);
      }
      
      // Update state with the response from server
      if (updatedExpense) {
        await this.updateExpenseInState(updatedExpense, categoryName, index);
      }
    } catch (e) {
      console.log("error", e);
    }
  };
  
  updateExpenseInState = async (updatedExpense, categoryName, originalIndex) => {
    console.log("updateExpenseInState called with:", updatedExpense);
    let category = JSON.parse(JSON.stringify(this.state.category));
    
    // Find the category
    let cat_Name = null;
    for (let i in category) {
      if (category[i].title === categoryName) {
        cat_Name = i;
        break;
      }
    }
    
    if (!cat_Name) {
      console.log("Category not found:", categoryName);
      return;
    }
    
    // Backend returns snake_case fields due to SnakeCaseNamingPolicy
    // Map them to the format used in the frontend state
    const expenseId = updatedExpense.id || updatedExpense._id;
    const fromDate = updatedExpense.from_date !== undefined ? updatedExpense.from_date : updatedExpense.fromDate;
    const toDate = updatedExpense.to_date !== undefined ? updatedExpense.to_date : updatedExpense.toDate;
    const updatedAt = updatedExpense.updated_at !== undefined ? updatedExpense.updated_at : updatedExpense.updatedAt;
    
    // Get current viewing date
    const dateParts = this.state.date.split("-");
    const currentDate = parseInt(dateParts[1] + dateParts[0], 10);
    
    // Find the expense by ID in the category
    const expenseIndex = category[cat_Name].data.findIndex(exp => exp.id === expenseId);
    
    if (expenseIndex !== -1) {
      // Check if the returned expense is valid for the current month
      const isValidForCurrentMonth = fromDate <= currentDate && toDate >= currentDate;
      
      if (isValidForCurrentMonth) {
        // Update existing expense
        const expense = category[cat_Name].data[expenseIndex];
        
        // Update fields from response (handle both snake_case and camelCase for safety)
        if (updatedExpense.title !== undefined) expense.title = updatedExpense.title;
        if (updatedExpense.sum !== undefined) expense.sum = updatedExpense.sum;
        if (updatedExpense.category !== undefined) expense.category = updatedExpense.category;
        if (fromDate !== undefined) expense.from_date = fromDate;
        if (toDate !== undefined) expense.to_date = toDate;
        if (updatedExpense.updated !== undefined) expense.updated = updatedExpense.updated;
        if (updatedAt !== undefined) expense.recored_updated = updatedAt;
        
        // For const_expense, calculate payments from to_date
        if (cat_Name === "const_expense") {
          const finalToDate = toDate !== undefined ? toDate : expense.to_date;
          if (finalToDate === 999999) {
            expense.payments = 0;
          } else {
            const finalFromDate = fromDate !== undefined ? fromDate : expense.from_date;
            
            if (finalFromDate && finalToDate) {
              const fromYear = Math.floor(finalFromDate / 100);
              const fromMonth = finalFromDate % 100;
              const toYear = Math.floor(finalToDate / 100);
              const toMonth = finalToDate % 100;
              
              const months = (toYear - fromYear) * 12 + (toMonth - fromMonth) + 1;
              expense.payments = Math.max(0, months);
            }
          }
        }
        
        category[cat_Name].data[expenseIndex] = expense;
        console.log("Updated expense at index:", expenseIndex, expense);
      } else {
        // Expense is no longer valid for current month (split happened)
        // Remove it from the current view
        category[cat_Name].data.splice(expenseIndex, 1);
        console.log("Removed expense (no longer valid for current month):", expenseId);
      }
    } else {
      // Expense not found by ID - this means a split happened
      // The backend returned a new expense with a new ID
      // We need to remove the original expense and add the new one
      console.log("Split detected - new expense ID returned from backend");
      
      // Remove the original expense at the original index if it exists
      if (originalIndex >= 0 && originalIndex < category[cat_Name].data.length) {
        const originalExpense = category[cat_Name].data[originalIndex];
        console.log("Removing original expense:", originalExpense);
        category[cat_Name].data.splice(originalIndex, 1);
      }
      
      // Add the new expense if it matches the current date range
      if (fromDate <= currentDate && toDate >= currentDate) {
        const expense = {
          sum: updatedExpense.sum,
          title: updatedExpense.title,
          id: expenseId,
          category: updatedExpense.category,
          from_date: fromDate,
          to_date: toDate,
          updated: updatedExpense.updated,
          recored_updated: updatedAt,
        };
        
        if (cat_Name === "const_expense") {
          if (toDate === 999999) {
            expense.payments = 0;
          } else {
            const fromYear = Math.floor(fromDate / 100);
            const fromMonth = fromDate % 100;
            const toYear = Math.floor(toDate / 100);
            const toMonth = toDate % 100;
            
            const months = (toYear - fromYear) * 12 + (toMonth - fromMonth) + 1;
            expense.payments = Math.max(0, months);
          }
        }
        
        category[cat_Name].data.push(expense);
        console.log("Added new expense from split:", expense);
      } else {
        console.log("New expense not added - outside current date range:", { expenseId, fromDate, toDate, currentDate });
      }
    }
    
    // Update state and re-render charts
    this.renderChart(this.updateCategoryHandler(category));
    
    // Refresh budget status after any update (budgets work for all category types)
    await this.load_categories();
  };
  onChange = async (
    categoryName,
    index,
    type,
    value,
    id,
    from_date,
    to_date,
    updated
  ) => {
    value = value.value;
    let category = JSON.parse(JSON.stringify(this.state.category));

    //if (type === "sum" && isNaN(+value)) return;
    if (type === "sum") {
      value = +value.split(" ")[0];
      if (isNaN(+value)) return;
    }

    if (type === "payments" && isNaN(+value)) return;
    if (type === "payments" && value === "") value = 0;

    let cat_Name = 0;
    for (let i in category) {
      if (category[i].title === categoryName) {
        cat_Name = i;
        break;
      }
    }
    if (index === "add") {
      const record = await this.Insert_new_Record_handler(
        cat_Name,
        this.state.date
      );
      delete record.owner;
      delete record.updatedAt;
      delete record.createdAt;
      if (cat_Name === "const_expense") record.payments = 0;
      category[cat_Name].data.push(record);
      
      // Refresh budget status after adding any record (budgets work for all category types)
      await this.load_categories();
    } else {
      let body = {};
      //updae

      if (cat_Name === "const_expense") {
        if (
          await this.split_expense(
            cat_Name,
            index,
            this.state.date,
            id,
            type,
            value
          )
        ) {
          return;
        } else {
          if (this.state.const_expence_update) return;
        }
      }

      if (type === "title") {
        category[cat_Name].data[index].title = value;
        body.title = value;
        // this.update_rec_by_id(id, body);
      }
      if (type === "sum") {
        body.sum = +value;
        category[cat_Name].data[index].sum = +value;
        //this.update_rec_by_id(id, body);
      }
      if (type === "category") {
        body.category = value;
        category[cat_Name].data[index].category = value;
        //this.update_rec_by_id(id, body);
      }

      if (type === "payments") {
        category[cat_Name].data[index].payments = +value;

        const fromDateValue = category[cat_Name].data[index].from_date;
        if (fromDateValue) {
          if (+value > 0) {
            let from_date = fromDateValue.toString();
            let year = +from_date.slice(0, 4);
            let month = +from_date.slice(4, 6);
            let months_count = month + +value - 1;
            let to_date = this.getNextDate(year, month, months_count);
            body.to_date = to_date;
            category[cat_Name].data[index].to_date = to_date;
          } else {
            body.to_date = 999999;
            category[cat_Name].data[index].to_date = 999999;
          }
          this.update_rec_by_id(id, body);
        }
      }
      //
    }
    this.renderChart(this.updateCategoryHandler(category));
    
    // Refresh budget status after any update (budgets work for all category types)
    await this.load_categories();
  };
  getNextDate(year, month, months) {
    // console.clear();
    let reuslt_month = month;
    let result = "";
    // console.log(year, month, months);
    for (let i = 0; i < months - month; i++) {
      reuslt_month++;
      //console.log(reuslt_month);
      if (reuslt_month > 12) {
        reuslt_month = 1;
        year++;
      }
    }
    if (reuslt_month < 10)
      result = year.toString() + "0" + reuslt_month.toString();
    else result = year.toString() + reuslt_month.toString();

    return result;
  }
  updateCategoryHandler = (category) => {
    let series = [0, 0, 0, 0];
    let tabal = [];
    tabal["income"] = 0;
    tabal["saving"] = 1;
    tabal["const_expense"] = 2;
    tabal["expense"] = 3;

    for (let c in category) {
      for (let index in category[c].data) {
        series[tabal[c]] += +category[c].data[index].sum;
      }
    }
    series[4] = series[0] - series[1] - series[2] - series[3];
    this.setState({ category });
    return series;
  };
  renderChart = (series) => {
    let pieChart = JSON.parse(JSON.stringify(this.state.pieChart));
    let barChart = JSON.parse(JSON.stringify(this.state.barChart));
    pieChart.series = series;
    barChart.series[0].data = series;
    this.setState({
      pieChart,
      barChart,
    });
  };
  //loads data by date and updates date
  selectDateHandler = async (date) => {
    let yyyymm_arr = date.split("-");
    let yyyymm = yyyymm_arr[1] + yyyymm_arr[0];
    const url =
      this.props.baseUrl +
      this.props.apiRouts.FETCH_BY_DATE +
      yyyymm +
      "&to_date=" +
      yyyymm;
    this.setState({
      loaded: false,
    });
    try {
      const expenses = await API.Get(url);
      if (expenses) {
        let category = JSON.parse(JSON.stringify(this.state.category));
        category.income.data = new Array(0);
        category.saving.data = new Array(0);
        category.const_expense.data = new Array(0);
        category.expense.data = new Array(0);
        for (let exp in expenses) {
          if (expenses[exp].type === "income") {
            category.income.data.push({
              sum: expenses[exp].sum,
              title: expenses[exp].title,
              id: expenses[exp].id,
              category: expenses[exp].category,
              recored_updated: expenses[exp].updatedAt,
            });
            continue;
          }
          if (expenses[exp].type === "saving") {
            category.saving.data.push({
              sum: expenses[exp].sum,
              title: expenses[exp].title,
              id: expenses[exp].id,
              category: expenses[exp].category,
              recored_updated: expenses[exp].updatedAt,
            });
            continue;
          }

          if (expenses[exp].type === "expense") {
            category.expense.data.push({
              sum: expenses[exp].sum,
              title: expenses[exp].title,
              id: expenses[exp].id,
              category: expenses[exp].category,
              recored_updated: expenses[exp].updatedAt,
            });
            continue;
          }
        }

        const const_expenses = await this.fetchGet(
          url + "&type=const_expense"
        );
        for (let exp in const_expenses) {
          let ex = {
            sum: const_expenses[exp].sum,
            title: const_expenses[exp].title,
            id: const_expenses[exp].id,
            from_date: const_expenses[exp].from_date,
            to_date: const_expenses[exp].to_date,
            category: const_expenses[exp].category,
            updated: const_expenses[exp].updated,
            recored_updated: const_expenses[exp].updatedAt,
          };
          let payments_ended = false;
          if (ex.to_date === 999999) ex.payments = 0;
          else {
            let years =
              +const_expenses[exp].to_date.toString().slice(0, 4) -
              +yyyymm_arr[1];
            let months =
              +const_expenses[exp].to_date.toString().slice(4, 6) -
              +yyyymm_arr[0];
            // Add 1 to include the end month as a payment
            // (e.g., Jan to Oct is 10 payments, not 9)
            ex.payments = years * 12 + months + 1;
            if (ex.payments < 1) {
              payments_ended = true;
            }
          }
          if (!payments_ended) category.const_expense.data.push(ex);
        }
        this.renderChart(this.updateCategoryHandler(category));
        this.setState({ date, loaded: true });
        
        // Refresh budget status when date changes
        await this.load_categories();
      }
    } catch (error) {}
  };
  Insert_new_Record_handler = async (type, date, _body) => {
    // console.log(type, date);
    const url = this.props.baseUrl + this.props.apiRouts.CREATE_NEW_REC;

    let new_date = date.split("-");

    let body = {};
    if (_body === undefined) {
      body = {
        type: type,
        title: "",
        category: "",
        sum: 0,
        from_date: new_date[1] + new_date[0],
        to_date: new_date[1] + new_date[0],
        updated: false,
      };
    }

    if (type === "const_expense") {
      body.to_date = 999999;
      body.is_payment = false; // New infinite fixed expenses are monthly amounts
    }
    if (_body !== undefined) body = _body;
    try {
      const { response, data } = await API.Post(url, body);
      if (response && response.status === 201) {
        return data;
      }
    } catch (error) {
      console.log(error);
    }
  };
  update_rec_by_id = async (id, body) => {
    console.log("update_rec_by_id - Sending request:", { id, body });

    const url =
      this.props.baseUrl + this.props.apiRouts.CREATE_NEW_REC + "/" + id;
    try {
      const { response, data } = await API.Patch(url, body);
      
      console.log("update_rec_by_id - Response:", { status: response?.status, data });
      
      if (response && response.ok) {
        return data;
      }
      return null;
    } catch (error) {
      console.error("Error updating expense:", error);
      return null;
    }
  };
  delete_rec_by_id = async (categoryName, id) => {
    // console.log(categoryName, id);
    let category = JSON.parse(JSON.stringify(this.state.category));
    let cat_Name = 0;
    for (let i in category) {
      if (category[i].title === categoryName) {
        cat_Name = i;
        break;
      }
    }
    // console.log("cat_Name", cat_Name);
    // console.log("id:", id);

    let delete_index = 0;
    for (let i in category[cat_Name].data) {
      if (category[cat_Name].data[i].id === id) {
        delete_index = i;
        break;
      }
    }
    
    // Get the expense title before removing it (for notification)
    const expenseTitle = category[cat_Name].data[delete_index]?.title || "Expense";
    
    let to_delete = true;
    if (cat_Name === "const_expense") {
      let temp_date = this.state.date.split("-");
      let date = temp_date[1] + temp_date[0];

      // console.log("date", date);
      // console.log("from_date", category[cat_Name].data[delete_index].from_date);
      if (date > category[cat_Name].data[delete_index].from_date)
        to_delete = false;

      let body_update = {};
      if (+temp_date[0] > 1) {
        body_update = { to_date: date - 1 };
      }
      if (+temp_date[0] === 1) {
        body_update = { to_date: temp_date[1] - 1 + "12" };
      }
      // console.log(body_update);
      await this.update_rec_by_id(id, body_update);
    }

    category[cat_Name].data.splice(delete_index, 1);
    this.renderChart(this.updateCategoryHandler(category));
    this.setState({
      category,
    });
    
    // Refresh budget status after deleting any record (budgets work for all category types)
    await this.load_categories();
    
    if (!to_delete) return;
    const url =
      this.props.baseUrl + this.props.apiRouts.CREATE_NEW_REC + "/" + id;
    try {
      const { response } = await API.Delete(url);
      
      // Show success notification
      if (response && (response.ok || response.status === 202)) {
        this.setState({
          showNotification: true,
          notificationMessage: `${expenseTitle} deleted successfully`,
        });
      }
    } catch (error) {
      console.error("Error deleting expense:", error);
    }
  };
  load_categories = async (yearMonth = null) => {
    // If yearMonth not provided, calculate from current date state
    if (!yearMonth && this.state.date) {
      const dateParts = this.state.date.split("-");
      yearMonth = parseInt(dateParts[1] + dateParts[0], 10);
    }
    
    let url = this.props.baseUrl + this.props.apiRouts.CATEGORIES;
    if (yearMonth) {
      url += `?yearMonth=${yearMonth}`;
    }
    
    try {
      const categories = await API.Get(url);
      if (categories) {
        let subCategory = [];
        let categoriesWithBudget = {};

        for (let index in categories) {
          const category = categories[index];
          subCategory.push({
            label: category.title,
            value: category.title,
          });
          // Store full category info with budget
          if (category.budget !== null && category.budget !== undefined) {
            categoriesWithBudget[category.title] = {
              budget: category.budget,
              spent: category.spent || 0,
              remaining: category.remaining || 0,
              isOverBudget: category.isOverBudget || false,
            };
          }
        }
        this.setState({
          subCategory,
          categoriesWithBudget,
        });
      }
    } catch (error) {
      this.setState({
        subCategory: [],
      });
    }
  };
  fetchGet = async (url) => {
    try {
      const result = await API.Get(url);
      return result || [];
    } catch (e) {
      return e;
    }
  };
  split_expense = async (type, index, date, id, prop, value) => {
    // console.log(this.state.const_expence_update);
    let temp_date = date.split("-");
    date = temp_date[1] + temp_date[0];

    if (this.state.const_expence_update) return false;

    let category = JSON.parse(JSON.stringify(this.state.category));

    let exp = category[type].data[index];
    // console.log(exp);

    //console.log(type, index, date, id, prop, value);

    if (+exp.from_date !== +date) {
      this.setState({ const_expence_update: true });
      // console.log("no equals");
      let body_update = {};
      if (+temp_date[0] > 1) {
        body_update = { to_date: date - 1, is_payment: false };
      }
      if (+temp_date[0] === 1) {
        body_update = { to_date: temp_date[1] - 1 + "12", is_payment: false };
      }

      await this.update_rec_by_id(id, body_update);
      category[type].data.splice(index, 1);

      delete exp.id;
      exp.from_date = date;
      exp.type = type;
      exp.is_payment = false; // New portion is also monthly amount

      if (prop === "title") exp.title = value;
      if (prop === "sum") exp.sum = value;
      if (prop === "category") exp.category = value;

      let new_exp = await this.Insert_new_Record_handler(type, date, exp);
      new_exp.payments = 0;
      // console.log("new_exp:", new_exp);
      // category[type].data.push(new_exp);
      category[type].data.splice(index, 0, new_exp);
      this.renderChart(this.updateCategoryHandler(category));
      this.setState({ const_expence_update: false });
      return true;
    }

    return false;
  };

  debounce(millSec, func) {
    let interval;
    setTimeout(() => {
      // console.log("debounce");
      clearTimeout(interval);
      return func();
    }, millSec);
  }
}

export default withRouter(Budget);
